// Base imports
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { ULID } from '@/store/models/uLID';
import project from '@/store/modules/project';
import { Project } from '@/store/models/project';
import notifier from '@/_helpers/notifier';
import template from './Edit.vue';

@Component({
	mixins: [template]
})
export default class Edit extends Vue {
	loading: boolean = true;

	async mounted(): Promise<void> {
		this.loading = true;
		// eslint-disable-next-line radix
		const id: ULID = this.$route.params.Pid;

		try {
			await project.get(id);
		} catch (error) {
			notifier.error('getting', 'project');
		} finally {
			this.loading = false;
		}
	}

	get project(): Project {
		return project.project;
	}
}
